import joinStyles from "../../utils/joinStyles";

const handlerHref = (href) => {
    window.location.href = href;
};

const getVariants = (variant) => {
    const variants = {
        loginButton: joinStyles([
            "h-[34px]",
            "w-[86px]",
            "rounded-[50px]",
            "bg-brand-blue-1",
            "text-white",
            "font-bold",
            "button-text",
            "flex",
            "items-center",
            "justify-center",
            "max-[450px]:h-[30px]",
            "max-[450px]:w-[86px]",
            "max-[450px]:rounded-[12px]",
        ]),
        openMenu: "bg-transparent",
        closeMenu: joinStyles(["bg-transparent", "rotate-180"]),
        createButton:"btn-create rounded-[8px] w-[180px] sm:w-[240px] md:px-0 h-[70px] sm:h-[50px] lg:h-[70px] button-text font-bold text-white text-[14px] md:text-[18px] block",
    };
    return variants[variant] || variants.loginButton;
};

const Button = ({ children, onClick, href, variant }) => {
    return (
        <button onClick={onClick || (() => handlerHref(href))} className={getVariants(variant)}>
            {children}
        </button>
    );
};

export default Button;
